import domready from "domready";

domready(() => {
	document.querySelectorAll('[data-toggle-for]').forEach(toggle => {
		const id = toggle.attributes['data-toggle-for'].value;

		toggle.addEventListener('click', () => {
			toggle.classList.toggle('on');
			document.getElementById(id).classList.toggle('on');
			//if (location && on) {
			//	location.hash = id;
		})

		if (location && location.hash === `#${id}`) {
			toggle.classList.add('on');
			document.getElementById(id).classList.add('on');
		}
	});
})